package com.karyadina.model

import kotlinx.serialization.Serializable

/**
 * Note type
 */
enum class NoteType {
    TEXT,
    CHECKLIST,
    VOICE_MEMO,
    SKETCH,
    CODE_SNIPPET
}

/**
 * Note priority/importance
 */
enum class NotePriority {
    NORMAL,
    IMPORTANT,
    STARRED
}

/**
 * Quick note
 */
@Serializable
data class QuickNote(
    val id: String,
    val title: String = "",
    val content: String,
    val noteType: String = NoteType.TEXT.name,
    val priority: String = NotePriority.NORMAL.name,
    val tags: List<String> = emptyList(),
    val color: String = "#FFFFFF",
    val createdAt: Long,
    val updatedAt: Long,
    val isPinned: Boolean = false,
    val isArchived: Boolean = false,
    val subject: String? = null,
    val linkedTask: String? = null, // task ID
    val checklistItems: List<ChecklistItem> = emptyList(),
    val imageUris: List<String> = emptyList(), // List of local file URIs
    val syncEnabled: Boolean = true // Enable cloud sync for this note
)

/**
 * Checklist item for notes
 */
@Serializable
data class ChecklistItem(
    val id: String,
    val text: String,
    val checked: Boolean = false,
    val order: Int
)

/**
 * Note folder/category
 */
@Serializable
data class NoteFolder(
    val id: String,
    val name: String,
    val color: String = "#9E9E9E",
    val noteCount: Int = 0,
    val createdAt: Long
)

/**
 * Note attachment
 */
@Serializable
data class NoteAttachment(
    val id: String,
    val noteId: String,
    val fileName: String,
    val filePath: String,
    val fileType: String,
    val fileSize: Long,
    val createdAt: Long
)

/**
 * Note search result
 */
@Serializable
data class NoteSearchResult(
    val note: QuickNote,
    val matchedFields: List<String>, // "title", "content", "tags"
    val relevanceScore: Float
)

/**
 * Note statistics
 */
@Serializable
data class NoteStats(
    val totalNotes: Int = 0,
    val todayNotes: Int = 0,
    val weekNotes: Int = 0,
    val archivedNotes: Int = 0,
    val pinnedNotes: Int = 0,
    val mostUsedTags: List<Pair<String, Int>> = emptyList()
)
